import StoreHelper from '../../../store/helper'
import EventBuilder from '../EventBuilder'

import { onDragend } from './dragend'
import _ from 'lodash'

export const onPressHoldEnd = (el, item) => {
  onDragend(el)

  const touchDropTarget = StoreHelper.getTouchDropTarget()
  if (!_.isEmpty(touchDropTarget)) {
    touchDropTarget.dispatchEvent(EventBuilder.createDropEvent(item))
  }
}
